// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/categories-bottom-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bgimage {
  width: 100%;
  height: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}
.top-bgimage-content {
  width: 60%;
  height: 230px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.top-bgimage-content-title {
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;
}
.top-bgimage-content img {
  height: 200px;
  object-fit: contain;
}

.bottom-bgimage {
  width: 100%;
  height: 768px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
}
.bottom-bgimage-title {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
}
.bottom-bgimage-descr {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 400;
  opacity: 0.8;
  max-width: 768px;
  text-align: center;
  color: #ffffff;
}
.bottom-bgimage button {
  margin-top: 32px;
  padding: 12px 24px;
  border-radius: 20px;
  border: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6E00FF;
  cursor: pointer;
}
.bottom-bgimage button span {
  margin-right: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #fefefe;
}

.categories {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 100px 0 36px 0;
}
.categories-left {
  display: flex;
  flex-direction: column;
  flex: 3 1;
}
.categories-left-title {
  font-size: 24px;
  font-weight: 700;
  color: #fefefe;
  margin-bottom: 16px;
}
.categories-left-active {
  color: #6E00FF !important;
}
.categories-left span {
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #898989;
  cursor: pointer;
}
.categories-left span:hover {
  color: #6E00FF;
}
.categories-right {
  flex: 9 1;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.categories-mobile {
  width: 100%;
  display: none;
  flex-direction: column;
}
.categories-mobile-item {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  margin-top: 10px;
  padding: 0 10px;
  box-sizing: border-box;
}
.categories-mobile-item img {
  width: 40px;
  height: 40px;
}
.categories-mobile-item span {
  text-align: center;
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #fefefe;
}

@media (max-width: 576px) {
  .top-bgimage {
    height: 180px;
  }
  .top-bgimage-content {
    width: 50%;
  }
  .top-bgimage-content img {
    height: 70px;
  }
  .top-bgimage-content-title {
    font-size: 20px;
    margin-left: 20px;
  }
  .categories {
    padding: 10px 0;
  }
  .categories-left {
    display: none;
  }
  .categories-right {
    display: none;
  }
  .categories-mobile {
    display: flex;
  }
  .bottom-bgimage {
    height: 350px;
  }
  .bottom-bgimage-title {
    font-size: 20px;
  }
  .bottom-bgimage-descr {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CategoriesPage/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;AACF;AAAE;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAEJ;AADI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGN;AADI;EAIE,aAAA;EACA,mBAAA;AAAN;;AAKA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;AAFF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAGE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AADJ;AAGE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AADJ;AAEI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAN;;AAKA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AAFF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAAN;AAEI;EACE,yBAAA;AAAN;AAEI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAAN;AACM;EACE,cAAA;AACR;AAGE;EACE,SAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;AADJ;AAGE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AADJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAAN;AACM;EACE,WAAA;EACA,YAAA;AACR;AACM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACR;;AAKA;EACE;IACE,aAAA;EAFF;EAGE;IACE,UAAA;EADJ;EAEI;IACE,YAAA;EAAN;EAEI;IACE,eAAA;IACA,iBAAA;EAAN;EAIA;IACE,eAAA;EAFF;EAGE;IACE,aAAA;EADJ;EAGE;IACE,aAAA;EADJ;EAGE;IACE,aAAA;EADJ;EAIA;IACE,aAAA;EAFF;EAGE;IACE,eAAA;EADJ;EAGE;IACE,eAAA;EADJ;AACF","sourcesContent":[".top-bgimage {\n  width: 100%;\n  height: 230px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background-image: url(\"../../assets/images/banner.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  &-content {\n    width: 60%;\n    height: 230px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    &-title {\n      text-align: center;\n      font-size: 40px;\n      font-weight: 700;\n      color: #ffffff;\n    }\n    & img {\n      // position: absolute;\n      // left: 100px;\n      // top: 0;\n      height: 200px;\n      object-fit: contain;\n    }\n  }\n}\n\n.bottom-bgimage {\n  width: 100%;\n  height: 768px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background-image: url(\"../../assets/images/categories-bottom-bg.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  &-title {\n    font-size: 36px;\n    font-weight: 700;\n    color: #ffffff;\n  }\n  &-descr {\n    margin-top: 24px;\n    font-size: 16px;\n    font-weight: 400;\n    opacity: 0.8;\n    max-width: 768px;\n    text-align: center;\n    color: #ffffff;\n  }\n  & button {\n    margin-top: 32px;\n    padding: 12px 24px;\n    border-radius: 20px;\n    border: 0;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #6E00FF;\n    cursor: pointer;\n    & span {\n      margin-right: 10px;\n      font-size: 16px;\n      font-weight: 500;\n      color: #fefefe;\n    }\n  }\n}\n\n.categories {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 100px 0 36px 0;\n  &-left {\n    display: flex;\n    flex-direction: column;\n    flex: 3;\n    &-title {\n      font-size: 24px;\n      font-weight: 700;\n      color: #fefefe;\n      margin-bottom: 16px;\n    }\n    &-active {\n      color: #6E00FF !important;\n    }\n    & span {\n      margin-top: 16px;\n      font-size: 16px;\n      font-weight: 500;\n      color: #898989;\n      cursor: pointer;\n      &:hover {\n        color: #6E00FF;\n      }\n    }\n  }\n  &-right {\n    flex: 9;\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n  &-mobile {\n    width: 100%;\n    display: none;\n    flex-direction: column;\n    &-item {\n      width: 100%;\n      height: 70px;\n      display: flex;\n      align-items: center;\n      background-color: #00000033;\n      border-radius: 12px;\n      margin-top: 10px;\n      padding: 0 10px;\n      box-sizing: border-box;\n      & img {\n        width: 40px;\n        height: 40px;\n      }\n      & span {\n        text-align: center;\n        margin-left: 10px;\n        font-size: 16px;\n        font-weight: 500;\n        color: #fefefe;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .top-bgimage {\n    height: 180px;\n    &-content {\n      width: 50%;\n      & img {\n        height: 70px;\n      }\n      &-title {\n        font-size: 20px;\n        margin-left: 20px;\n      }\n    }\n  }\n  .categories {\n    padding: 10px 0;\n    &-left {\n      display: none;\n    }\n    &-right {\n      display: none;\n    }\n    &-mobile {\n      display: flex;\n    }\n  }\n  .bottom-bgimage {\n    height: 350px;\n    &-title {\n      font-size: 20px;\n    }\n    &-descr {\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
